import { AxiosError, AxiosResponse } from 'axios'
import { useMutation } from 'react-query'

import * as requests from './requests'
import { Onboarding } from './types'
import { ResponseError } from '../../types'

export const useOnboardingMutation = () =>
  useMutation<AxiosResponse<Onboarding>, AxiosError<ResponseError>, Onboarding>(requests.onboarding)
